import {Component, EventEmitter, Input, OnChanges, Output, TemplateRef} from '@angular/core';
import {AutoDestroy} from '@ox/utils';
import {BsModalService, ModalOptions} from 'ngx-bootstrap/modal';
import {Subject, takeUntil} from 'rxjs';

@Component({
  selector: 'ox-general-modal',
  templateUrl: './general-modal.component.html'
})
export class GeneralModalComponent<T> implements OnChanges {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  @Input() show = false;
  @Input() options?: ModalOptions = {};
  @Input() bodyComponent!: T;
  @Input() bindingInputs: { [key: string]: unknown } = {};
  @Input() bindingOutputs: { [key: string]: unknown } = {};
  @Output() showChange = new EventEmitter();

  constructor(private modal: BsModalService) {
  }

  ngOnChanges() {
    if (this.show) this.open();
  }

  open() {
    const modalComponent = this.bodyComponent as unknown;
    const modal = this.modal.show(modalComponent as TemplateRef<unknown>, this.options);
    if (!modal) throw Error('Modal Error');
    const modalComp = modal.content;
    if (modalComp) modalComp['modalRef'] = modal;
    if (modalComp) Object.keys(this.bindingInputs).forEach(b => modalComp[b] = this.bindingInputs[b]);
    if (modalComp) Object.keys(this.bindingOutputs).forEach(b => modalComp[b] = this.bindingOutputs[b]);
    const modalHide = modal.onHide;
    if (modalHide) {
      modalHide
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => modalHide.complete(),
          complete: () => this.showChange.emit(false)
        });
    }
  }
}
